export default __webpack_public_path__ + "static/media/pd7.eebac091.jpg";